import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NSettingApi = global.NSettingApi
/**
 * 配置相关接口
 */
class SettingApi extends Http {
  /**
   * 用于获得哪些字段可选择接口
   * @returns
   */
  public async getSendFields() {
    return await super.request<NSettingApi.SendFieldResp>({
      url: '/crossbowSystem/getSelectableFields',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: null
    })
  }

  /**
   * 创建体现消息推送场景
   * @param data 请求参数
   * @returns
   */
  public async addWithdrawMessageScene(data: NSettingApi.WithdrawMessageSceneReq) {
    return await super.request<any>({
      url: '/crossbowSystem/createWithdrawalAlert',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  /**
   * 更新体现消息推送场景
   * @param data 请求参数
   * @returns
   */
  public async updateWithdrawMessageScene(data: NSettingApi.WithdrawMessageSceneReq) {
    return await super.request<any>({
      url: '/crossbowSystem/updateWithdrawalAlert',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  /**
   * 查询提现消息推送场景列表
   * @param data 请求参数
   * @returns
   */
  public async queryWithdrawMessageScenePage(data: NSettingApi.WithdrawMessageScenePageReq) {
    return await super.request<NSettingApi.WithdrawMessageScenePageResp>({
      url: '/crossbowSystem/listWithdrawalAlerts',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async queryWithdrawMessageSceneById(id: number) {
    return await super.request<NSettingApi.WithdrawMessageSceneInfoResp>({
      url: `/crossbowSystem/withdrawal-alert/${id}`,
      method: RequestType.Get,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}

export default SettingApi
